"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLegendConfigSelector = void 0;
var re_reselect_1 = __importDefault(require("re-reselect"));
var position_style_1 = require("../../components/legend/position_style");
var get_chart_id_1 = require("./get_chart_id");
var get_settings_specs_1 = require("./get_settings_specs");
exports.getLegendConfigSelector = re_reselect_1.default([get_settings_specs_1.getSettingsSpecSelector], function (_a) {
    var flatLegend = _a.flatLegend, legendAction = _a.legendAction, legendColorPicker = _a.legendColorPicker, legendMaxDepth = _a.legendMaxDepth, legendPosition = _a.legendPosition, legendStrategy = _a.legendStrategy, onLegendItemClick = _a.onLegendItemClick, showLegend = _a.showLegend, onLegendItemMinusClick = _a.onLegendItemMinusClick, onLegendItemOut = _a.onLegendItemOut, onLegendItemOver = _a.onLegendItemOver, onLegendItemPlusClick = _a.onLegendItemPlusClick, showLegendExtra = _a.showLegendExtra;
    return {
        flatLegend: flatLegend,
        legendAction: legendAction,
        legendColorPicker: legendColorPicker,
        legendMaxDepth: legendMaxDepth,
        legendPosition: position_style_1.getLegendPositionConfig(legendPosition),
        legendStrategy: legendStrategy,
        onLegendItemClick: onLegendItemClick,
        showLegend: showLegend,
        onLegendItemMinusClick: onLegendItemMinusClick,
        onLegendItemOut: onLegendItemOut,
        onLegendItemOver: onLegendItemOver,
        onLegendItemPlusClick: onLegendItemPlusClick,
        showLegendExtra: showLegendExtra,
    };
})(get_chart_id_1.getChartIdSelector);
//# sourceMappingURL=get_legend_config_selector.js.map